import React, { useState } from 'react';

import BasePrompt from 'components/base/prompt/BasePrompt';

import './SmsTipsPrompt.scss';

const DotView = ({}) => {
  return (
    <div className="dot-container">
      <div className="dot" />
    </div>
  );
};

function SmsTipsPrompt({
  show = false,
  onHide = () => {},
  onConfirm = () => {},
}) {
  const otherBody = () => {
    return (
      <div className="sms-tip-container d-flex flex-column">
        <span className="tip-h1">{'1. Character limits:'}</span>
        <div className="tip-h2 d-flex flex-row">
          <DotView />
          <span>
            {
              'English/standard characters: up to 160 characters per message (153 if split).'
            }
          </span>
        </div>
        <div className="tip-h2 d-flex flex-row">
          <DotView />
          <span>
            {
              'Chinese/Unicode characters: up to 70 characters per message (67 if split).'
            }
          </span>
        </div>
        <div className="tip-h3 d-flex flex-row">
          <DotView />
          <span>
            {
              'Messages containing only English characters are limited to 160 characters. If any Chinese/Unicode characters are included, the limit is reduced to 70 characters.'
            }
          </span>
        </div>
        <div className="tip-h2 d-flex flex-row">
          <DotView />
          <span>{'One Chinese character typically equals 2 characters.'}</span>
        </div>
        <div className="tip-h2 d-flex flex-row">
          <DotView />
          <span>
            {
              'One emoji usually counts as 2 or more characters, especially complex or combined emojis.'
            }
          </span>
        </div>
        <div className="tip-h2 d-flex flex-row">
          <DotView />
          <span>{'Spaces are counted as one character.'}</span>
        </div>

        <span className="tip-h1">{'2. Long messages:'}</span>
        <div className="tip-h2 d-flex flex-row">
          <DotView />
          <span>
            {
              'Messages exceeding the limit will be split into multiple parts. Charges apply per part.'
            }
          </span>
        </div>

        <span className="tip-h1">{'3. URLs:'}</span>
        <div className="tip-h2 d-flex flex-row">
          <DotView />
          <span>
            {
              'If the message breaks at a URL, it may not function properly in some apps.'
            }
          </span>
        </div>

        <span className="tip-h1">{'4. Dynamic length of parameters:'}</span>
        <div className="tip-h2 d-flex flex-row">
          <DotView />
          <span>
            {
              'Parameters like {{FirstName}}, {{LastName}} will vary in length depending on customer data.'
            }
          </span>
        </div>

        <span className="tip-h1">{'5. Telecom modifications:'}</span>
        <div className="tip-h2 d-flex flex-row">
          <DotView />
          <span>
            {
              'Some telecom providers may append additional content (e.g. unsubscribe links or tags), which can increase the final message length.'
            }
          </span>
        </div>

        <span className="tip-h1 tip-title-bold">
          {
            '6. Try testing your message before sending it by sending draft messages to the test accounts.'
          }
        </span>
      </div>
    );
  };

  return (
    <BasePrompt
      show={show}
      closeAction={onHide}
      rightButton={{
        text: 'OK',
        action: onConfirm,
      }}
      title={'Tips'}
      otherBody={otherBody}
    />
  );
}

export default SmsTipsPrompt;
